module.exports = __webpack_public_path__ + "img/T-360_responder_First_Frame.56953bfd.png";